import { ITab } from 'components/organisms/Tabs';

export enum EMyStoriesTabs {
    Reading = 'reading',
    Writing = 'writing',
}

export type TMyStoriesTabs = ITab<EMyStoriesTabs>[];
